// hooks/useCurrentCompany.ts

import { useQuery } from "@tanstack/react-query";
import { getCurrentCompanyAction } from "../actions/current-companyInfo.actions";

export const useCurrentCompanyInfo = (token?: string | null, activeCompanyId?: number | string | null) => {
  return useQuery({
    queryKey: ["current-company", token, activeCompanyId],
    queryFn: () => getCurrentCompanyAction(activeCompanyId!),
    enabled: !!token && activeCompanyId != null,
    retry: false,
  });
};
